import React, { useState } from 'react'
import { useHistory, Link } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import {
  Container,
  FormWrap,
  Icon,
  FormContent,
  Form,
  FormH1,
  FormLabel,
  FormInput,
  FormButton,
  Text
} from '../Signup/SignupElements'

const SignUp = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const { signup } = useAuth()
  const history = useHistory()

  const handleSubmit = async (e) => {
    e.preventDefault()
    
    if (password !== confirmPassword) {
      toast.error('Passwords do not match')
      return
    }
    
    if (password.length < 6) {
      toast.error('Password must be at least 6 characters')
      return
    }
    
    setLoading(true)

    try {
      const result = await signup(email, password)
      
      if (result.success) {
        toast.success('Account created successfully! Please check your email to verify.')
        history.push('/signin')
      } else {
        toast.error(result.error || 'Signup failed')
      }
    } catch (error) {
      toast.error('An unexpected error occurred')
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Container>
        <FormWrap>
          <Icon to='/'>Finova</Icon>
          <FormContent>
            <Form onSubmit={handleSubmit}>
              <FormH1>Create your account</FormH1>
              <FormLabel htmlFor='email'>Email</FormLabel>
              <FormInput
                type='email'
                id='email'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <FormLabel htmlFor='password'>Password</FormLabel>
              <FormInput
                type='password'
                id='password'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={6}
              />
              <FormLabel htmlFor='confirmPassword'>Confirm Password</FormLabel>
              <FormInput
                type='password'
                id='confirmPassword'
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                minLength={6}
              />
              <FormButton type='submit' disabled={loading}>
                {loading ? 'Creating account...' : 'Sign Up'}
              </FormButton>
              <Text>
                Already have an account? <Link to='/signin'>Sign in</Link>
              </Text>
            </Form>
          </FormContent>
        </FormWrap>
      </Container>
      <ToastContainer />
    </>
  )
}

export default SignUp
